module.exports = __webpack_public_path__ + "static/media/2.c3ae0b5c.gif";